import { StandardLink } from 'components/standardLink/standardLink';
import * as React from 'react';

export const SupportEmailLink: React.FC = () => (
  <StandardLink to="mailto:support@schedulelab.io">support@schedulelab.io</StandardLink>
);
